import { render, staticRenderFns } from "./killRecord.vue?vue&type=template&id=70545e52&scoped=true&"
import script from "./killRecord.vue?vue&type=script&lang=js&"
export * from "./killRecord.vue?vue&type=script&lang=js&"
import style0 from "./killRecord.vue?vue&type=style&index=0&id=70545e52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70545e52",
  null
  
)

export default component.exports